<div class="page-wrapper table-wrapper">
    <app-header
            [headerText]="'GENERAL.USER_MANAGEMENT' | translate"
            [headerParagraph]="'USER_MANAGEMENT.HEADER_INFO' | translate"
            [backButtonDisplayed]="true"
            [backButtonLabel]="'GENERAL.BACK' | translate"
            [leaveButton]="true"
            [leaveButtonLabel]="'GENERAL.LOGOUT' | translate"
            [showSearch]="true"
            [searchTriggerDelay]="0"
            (buttonEvent)="onBack()"
            (searchTextEvent)="filterUsers($event)"
            (leaveIndication)="onLogOut()">
    </app-header>
    <div class="table" style="height: 100%"
         infinite-scroll
         [infiniteScrollDistance]="2"
         [infiniteScrollThrottle]="1000"
         [scrollWindow]="false"
         [immediateCheck]="true"
         (scrolled)="onTableScroll()">
        <table>
            <thead>
                <tr>
                    <th>{{'GENERAL.NAME' | translate}}</th>
                    <th class="narrow-heading">{{'GENERAL.USER_TYPE' | translate}}</th>
                    <th class="narrow-heading">{{'USER.MORE_INFO' | translate}}</th>
                    <th class="narrow-heading">{{'GENERAL.EDUCATION' | translate}}</th>
                    <th class="narrow-heading">{{'USER.SETTINGS' | translate}}</th>
                    <th class="narrow-heading">{{'USER.ACTIONS' | translate}}</th>
                </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let user of organizationUsers">
                <tr user-item
                    [user]="user"
                    [organizationDefaultSettings]="organizationDefaultSettings"
                    [indications]="indications"
                    [useCases]="useCases"
                    [saveDisabled]="saveDisabled"
                    [loggedUserData]="loggedUserInfo$ | async"
                    [filterText]="searchText"
                    (educationPopUpEvent)="openEducationDialog(user)"
                    (hasEducationEvent)="educationExists($event)"></tr>
            </ng-container>
            <tr class="last-row">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="btn-wrapper">
        <app-button
                [cssClasses]="'btn regular full-width solid__blue-07'"
                (buttonClicked)="createUserDialog()">
            {{'GENERAL.CREATE_NEW_USER' | translate}}
        </app-button>
    </div>
</div>
